import { useState, useEffect } from 'react';

export default function BenefitsSection() {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        setFontsLoaded(true);
      });
    } else {
      setFontsLoaded(true);
    }
  }, []);

  const fontFamily = fontsLoaded ? 'Montserrat, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';
  const fontFamilyInter = fontsLoaded ? 'Inter, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';

  const benefits = [
    { icon: 'ri-brain-line', title: 'Troque escassez por mentalidade de riqueza', gradient: 'from-yellow-400 to-yellow-600' },
    { icon: 'ri-flashlight-line', title: 'Ative o foco e a consistência diária', gradient: 'from-yellow-500 to-orange-500' },
    { icon: 'ri-compass-3-line', title: 'Desenvolva hábitos mentais milionários', gradient: 'from-yellow-400 to-yellow-500' },
    { icon: 'ri-briefcase-line', title: 'Crie magnetismo financeiro', gradient: 'from-yellow-600 to-yellow-400' },
    { icon: 'ri-key-2-line', title: 'Desperte seu poder interno', gradient: 'from-yellow-500 to-yellow-600' }
  ];

  return (
    <section className="relative py-16 sm:py-32 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-20">
          <span className="text-yellow-400 text-xs sm:text-sm font-bold tracking-widest uppercase mb-4 block" style={{ fontFamily }}>
            O PODER DA REPROGRAMAÇÃO
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-4 sm:mb-6" style={{ fontFamily }}>
            Ative o <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">Modo Milionário</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-4xl mx-auto leading-relaxed px-4" style={{ fontFamily: fontFamilyInter }}>
            Este guia revela o método para eliminar crenças de escassez e instalar o padrão mental da abundância
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="group relative bg-gradient-to-br from-gray-900 to-black p-6 sm:p-8 rounded-2xl border border-yellow-500/20 hover:border-yellow-500/60 transition-all duration-500 hover:transform hover:scale-105">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/0 to-yellow-500/0 group-hover:from-yellow-500/5 group-hover:to-yellow-500/10 rounded-2xl transition-all duration-500" />
              
              <div className={`relative w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${benefit.gradient} rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg shadow-yellow-500/30 group-hover:shadow-yellow-500/50 transition-all duration-500`}>
                <i className={`${benefit.icon} text-black text-2xl sm:text-3xl`}></i>
              </div>
              
              <p className="relative text-yellow-400 font-bold text-sm sm:text-base text-center leading-snug" style={{ fontFamily }}>
                {benefit.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
